<template>
    <div class="col-lg-6 offset-lg-3 mx-auto mb-5 max-w-[497px] rounded-md legacy-md:p-8 legacy-md:shadow-xl">
        <div class="mb-10">
            <a
                class="btn-link text-sm text-content-secondary hover:text-content-primary focus:text-content-primary"
                href="/user/mfa/send"
                tabindex="1"
                ><font-awesome-icon
                    class="mr-1"
                    :icon="['fas', 'angle-left']"
                />Back</a
            >
        </div>

        <div class="mb-3 mt-5 flex">
            <h3 class="text-left font-inter text-xl font-semibold">Multi-factor security</h3>
        </div>
        <p class="mb-10 text-base">Please enter the code.</p>

        <div class="mb-5 flex">
            <div class="grow">
                <div class="mb-3">
                    <label class="font-inter text-sm font-normal">Authentication Code</label>
                    <code-input
                        @code="captureCode"
                        @keyup.enter="currentUserService.verifyMFACode(props.loginRoute, codeValues)"
                    />
                    <div class="mt-3 text-center">
                        <a
                            class="btn-link"
                            href=""
                            @click="
                                e => {
                                    e.preventDefault();
                                    currentUserService.requestMFACode(props.getCodeRoute, 'sms');
                                }
                            "
                            >Resend text</a
                        >
                        |
                        <a
                            class="btn-link"
                            href=""
                            @click="
                                e => {
                                    e.preventDefault();
                                    currentUserService.requestMFACode(props.getCodeRoute, 'call');
                                }
                            "
                            >Call me again</a
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="my-10 flex text-center">
            <div class="grow">
                <button
                    class="btn btn-brand btn-circle w-100 text-base"
                    :disabled="loginButtonDisabled"
                    tabindex="4"
                    @click="currentUserService.verifyMFACode(props.loginRoute, codeValues)"
                >
                    Login
                </button>
            </div>
        </div>
        <div class="row">
            <div
                class="col"
                style="text-align: center"
            >
                <p>
                    Need help? Please contact
                    <a
                        v-if="supportEmail"
                        class="btn-link underline"
                        :href="'mailto:' + supportEmail"
                        >{{ supportEmail }}</a
                    >
                    <template v-else>your title company</template>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import codeInput from '@/components/auth/CodeInput.vue';
import { useCurrentUserService } from '@/services/current-user.service';
import { ref } from 'vue';

const props = defineProps<{
    getCodeRoute: string;
    loginRoute: string;
    supportEmail: string | null; // Branch['support_email']
}>();

const currentUserService = useCurrentUserService();
const loginButtonDisabled = ref(true);
const codeValues = ref('');

function captureCode(code: string) {
    codeValues.value = code;
    if (code.length === 6) {
        loginButtonDisabled.value = false;
    } else {
        loginButtonDisabled.value = true;
    }
}
</script>
